import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
  OnDestroy,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { fromEvent, merge, Subject, take, takeUntil, timer } from 'rxjs';
import { DashboardComponent } from '../../dashboard/dashboard.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { DashboardService } from '../../services/dashboard.service';
import { WaitService } from '../../../../shared/services/wait.service';
import { SingleValueRequestService } from '../../services/single-value-request.service';

@Component({
  selector: 'app-dashboard-preview',
  templateUrl: './dashboard-preview.component.html',
  styleUrls: ['./dashboard-preview.component.scss'],
  imports: [MatProgressBarModule, DashboardComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [DashboardService, WaitService, SingleValueRequestService],
})
export class DashboardPreviewComponent implements AfterViewInit, OnDestroy {
  private cd = inject(ChangeDetectorRef);
  private elRef = inject(ElementRef);

  private unsubscribe = new Subject<void>();

  private _dashboardId = null;

  setPos() {
    let val = 0;
    const el: HTMLElement = this.elRef.nativeElement;
    const elDiv: HTMLElement = el?.querySelector('div');
    if (el && elDiv) {
      const offsetTop = el.offsetTop;
      const elHeight = elDiv.getBoundingClientRect()?.height;
      const diff = window.innerHeight - offsetTop - elHeight;
      if (diff < 0) val = diff - 40;
    }
    this.elRef.nativeElement.style.transform = `translateY(${val}px)`;
  }

  get dashboardId() {
    return this._dashboardId;
  }

  @Input() set dashboardId(value) {
    if (this._dashboardId !== null) {
      this.loaded = false;
      this._dashboardId = value;
      this.setupContent();
    }
    this._dashboardId = value;
  }

  loaded = false;

  src = null;

  constructor() {
    merge(fromEvent(document, 'mousemove'), timer(0, 500))
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(() => this.updateView());
  }

  ngAfterViewInit() {
    timer(500)
      .pipe(take(1), takeUntil(this.unsubscribe))
      .subscribe(() => this.setupContent());
  }

  private setupContent() {
    this.src = null;
    if (!this.dashboardId) return;
    this.loaded = true;
    this.updateView();
  }

  @HostListener('document:mousemove', ['$event'])
  mouseenter(event: MouseEvent) {
    this.mouseLeft = event.clientX + 'px';
    this.mouseTop = event.clientY + 'px';
  }

  @HostBinding('style.left') mouseLeft = '1px';

  @HostBinding('style.top') mouseTop = '1px';

  updateView() {
    this.setPos();
    this.cd.detectChanges();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
